export default "__VITE_ASSET__DAzj0V4b__"